import {config} from "../config";

export class websocket {
    static _socket: WebSocket;
    static _listeners: any = {};
    static _listenersOnce: any = {};
    static connected: boolean = false;
    static _sendQueue: any[] = [];

    /**
     * Connect to the websocket server
     */
    static connect(token?: string) {
        if (websocket._socket && websocket._socket.readyState !== WebSocket.CLOSED) return console.warn("Connect cancelled, websocket still open!");

        let url = config.get("websocket");
        if (token) url += "?token=" + token;

        this._socket = new WebSocket(url);
        this._socket.onopen = this._onOpen;
        this._socket.onmessage = this._onMessage;
        this._socket.onclose = this._onClose;
    }

    static login() {
        const token = config.get("token");
        if (!token) return;
        websocket.emit("login", {token});
    }

    static _onMessage(body: any) {
        let {data} = body;
        if (!data) return;
        try {
            data = JSON.parse(data);
        } catch (e) {
            return console.log("failed to parse websocket message", e);
        }
        websocket._emit(data.type || data.cmd, data);
    }

    static _onOpen() {
        websocket.connected = true;
        websocket._emit("open");

        const dequeue = () => {
            if (!websocket._sendQueue.length) return;

            const message = websocket._sendQueue.shift();
            websocket._socket.send(message);

            setTimeout(dequeue, 100);
        };

        dequeue();
    }

    static _onClose() {
        websocket.connected = false;
        websocket._emit("close");

        setTimeout(() => {
            websocket._socket.readyState === WebSocket.CLOSED && websocket.connect();
        }, 10 * 1000);
    }

    static _emit(type: string, data?: any) {
        if (data?._requestId) type += "@" + data?._requestId;
        websocket._listeners[type] && websocket._listeners[type].forEach((cb: (data: any) => void) => cb(data));
        websocket._listenersOnce[type] && websocket._listenersOnce[type].forEach((cb: (data: any) => void) => {
            cb(data);
            websocket._listenersOnce[type].splice(websocket._listenersOnce[type].indexOf(cb), 1);
        });
    }

    /**
     * Send message with cmd and data
     * @param {string} cmd
     * @param {object|undefined} data
     */
    static emit(cmd: string, data: any | undefined) {
        const request = JSON.stringify({cmd, data});

        if (!websocket.connected) return websocket._sendQueue.push(request);
        websocket._socket.send(request);
    }

    static async cmd(cmd: string, data: { [key: string]: any }) {
        const _requestId = crypto.randomUUID();
        const request = JSON.stringify({cmd, data, _requestId});

        if (!websocket.connected) {
            websocket._sendQueue.push(request);
        } else {
            websocket._socket.send(request);
        }

        return new Promise((resolve, reject) => {
            websocket.once(cmd + "@" + _requestId, ({data, error}) => {
                if (error) return reject(error);
                resolve(data);
            });
        });
    }

    /**
     * Register handler for message type
     * @param {string} type
     * @param {function} cb
     */
    static on(type: string, cb: (data: any) => void) {
        if (!websocket._listeners[type]) {
            websocket._listeners[type] = [];
        }
        websocket._listeners[type].push(cb);
    }

    /**
     * Remove handler for message type
     * @param {string} type
     * @param {function} cb
     */
    static off(type: string, cb: (data: any) => void) {
        if (!websocket._listeners[type] || !websocket._listeners[type].includes(cb)) return;
        websocket._listeners[type].splice(websocket._listeners[type].indexOf(cb), 1);
    }

    /**
     * Remove handler for message type
     * @param {string} type
     * @param {function} cb
     */
    static offOnce(type: string, cb: (data: any) => void) {
        if (!websocket._listenersOnce[type] || !websocket._listenersOnce[type].includes(cb)) return;
        websocket._listenersOnce[type].splice(websocket._listenersOnce[type].indexOf(cb), 1);
    }

    /**
     * Register handler for message type, removed after it got called
     * @param {string} type
     * @param {function} cb
     */
    static once(type: string, cb: (data: any) => void) {
        if (!websocket._listenersOnce[type]) {
            websocket._listenersOnce[type] = [];
        }
        websocket._listenersOnce[type].push(cb);
    }
}

// ws.on("users", ({users}) => store.commit("setUsers", users));
